export default "__VITE_ASSET__DwFScgK0__"